<template>
    <ion-app>
      <ion-router-outlet />
    </ion-app>
  </template>
  
  <script>
  import { IonApp, IonRouterOutlet } from '@ionic/vue';
  
  export default {
    name: 'App',
    components: {
      IonApp,
      IonRouterOutlet
    },
    mounted() {
      this.loadTheme();
    },
    methods: {
      loadTheme() {
        const savedTheme = localStorage.getItem('theme') || 'dark';
        this.applyTheme(savedTheme);
      },
      applyTheme(theme) {
        document.body.classList.remove('dark-theme', 'light-theme');
        if (theme === 'dark') {
          document.body.classList.add('dark-theme');
        } else if (theme === 'light') {
          document.body.classList.add('light-theme');
        }
      }
    }
  }
  </script>